import { ROUTE } from "../../../routes";
import { ButtonTypeTokens, FetchPortfolioModalType, InputStateToken } from "@voltmoney/schema";
import { AssetRepositoryMap, AssetRepositoryType, getAppHeader } from "../../../configs/config";
import { api } from "../../../configs/api";
import SharedPropsService from "../../../SharedPropsService";
export const showCamsFetchErrorHandle = async (standardUtilities, errorData) => {
    const isFetchedErrorShowOnce = await SharedPropsService.getIsFetchedErrorShowOnce();
    await standardUtilities.setDatastore(ROUTE.MF_FETCH_PORTFOLIO, 'fetchPortfolioModals', {
        height: 0,
        visible: true,
        type: isFetchedErrorShowOnce
            ? FetchPortfolioModalType.IMMEDIATE
            : errorData?.retryNextRTA
                ? errorData?.retryType
                : FetchPortfolioModalType.IMMEDIATE,
        title: errorData?.header,
        subtitle: errorData?.message,
        primaryCtaTitle: errorData?.primaryCtaText,
        tertiaryCTATitle: errorData?.tertiaryCtaText,
        primaryCtaAction: errorData?.primaryCtaAction
            && (errorData?.primaryCtaAction !== "null") ? {
            routeId: ROUTE.MF_FETCH_PORTFOLIO,
            type: `${errorData?.primaryCtaAction}`,
            payload: {}
        } : undefined,
        tertiaryCTAAction: errorData?.tertiaryCtaAction &&
            (errorData?.tertiaryCtaAction !== "null") ? {
            routeId: ROUTE.MF_FETCH_PORTFOLIO,
            type: `${errorData?.tertiaryCtaAction}`,
            payload: {}
        } : undefined,
        loadingTime: errorData?.loaderTimingInMilliSec ? errorData?.loaderTimingInMilliSec : 0,
        loaderText: (errorData?.retryType === FetchPortfolioModalType.LOADER)
            ? `Fetching your portfolio from ${errorData?.assetRepository === 'CAMS' ? 'Cams' : 'Kfintech'}`
            : undefined,
        onModalClose: () => {
            standardUtilities.setDatastore(ROUTE.MF_FETCH_PORTFOLIO, 'fetchPortfolioModals', {
                visible: false,
            });
        }
    });
};
export const retryFetch = async (standardUtilities, extraParams) => {
    await SharedPropsService.setIsFetchedErrorShowOnce(true);
    const {} = standardUtilities;
    const {} = extraParams;
    //switching the RTA
    const assetRepository = AssetRepositoryType[extraParams.fetchPortfolioPayload.assetRepository] === AssetRepositoryType.KARVY
        ? AssetRepositoryType.CAMS
        : AssetRepositoryType.KARVY;
    await standardUtilities.setDatastore(ROUTE.MF_FETCH_PORTFOLIO, "fetchCTA", {
        label: "Get my portfolio",
        type: ButtonTypeTokens.LargeFilled,
        loading: true,
    });
    const fetch2ndRTAInitResponse = await standardUtilities.network.post(`${api.mfFetchInitV3}`, {
        ...extraParams.fetchPortfolioPayload,
        assetRepository: assetRepository,
    }, {
        headers: await getAppHeader(),
    });
    if (fetch2ndRTAInitResponse?.status === 200) {
        const fetch2ndRTAInitResponseData = fetch2ndRTAInitResponse?.data;
        const errorData = fetch2ndRTAInitResponseData?.stepResponseObject?.error;
        if (fetch2ndRTAInitResponseData?.status?.toUpperCase() === 'FAILURE') {
            standardUtilities.instrumentTrack('GET_MF_PORTFOLIO_AUTH_USER', {
                result: false,
                rta: assetRepository,
                error_type: fetch2ndRTAInitResponseData?.stepResponseObject?.error?.header
            });
            await standardUtilities.setDatastore(ROUTE.MF_FETCH_PORTFOLIO, "fetchCTA", {
                label: "Get my portfolio",
                type: ButtonTypeTokens.LargeFilled,
                loading: false,
            });
            await showCamsFetchErrorHandle(standardUtilities, {
                ...errorData,
                //added conditions on FE Side on retry
                retryNextRTA: false
            });
        }
        else {
            standardUtilities.instrumentTrack('GET_MF_PORTFOLIO_AUTH_USER', {
                result: true,
                rta: assetRepository,
                error_type: ''
            });
            //success case
            await standardUtilities.setDatastore(ROUTE.OTP_AUTH_CAS, "input", {
                state: InputStateToken.DEFAULT,
                charLimit: AssetRepositoryMap.get(assetRepository).OTP_LENGTH,
            });
            await standardUtilities.setDatastore(ROUTE.OTP_AUTH_CAS, "subTitle", {
                label: `${AssetRepositoryMap.get(assetRepository).NAME} depository has sent an OTP to `,
            });
            await standardUtilities.setDatastore(ROUTE.MF_FETCH_PORTFOLIO, "fetchCTA", {
                label: "Get my portfolio",
                type: ButtonTypeTokens.LargeFilled,
                loading: false,
            });
            await standardUtilities.navigate(ROUTE.OTP_AUTH_CAS, {
                assetRepository: assetRepository,
                identifier: fetch2ndRTAInitResponseData.stepResponseObject.success.identifier,
                otpChannel: fetch2ndRTAInitResponseData.stepResponseObject.success.otpChannel,
                noOfDigits: fetch2ndRTAInitResponseData.stepResponseObject.success.noOfDigits,
                isRetryAllowed: extraParams.isRetryAllowed
            });
        }
    }
    else {
        await standardUtilities.setDatastore(ROUTE.MF_FETCH_PORTFOLIO, "fetchCTA", {
            label: "Get my portfolio",
            type: ButtonTypeTokens.LargeFilled,
            loading: false,
        });
    }
};
export const CamsFetchErrorHandle = async (standardUtilities, extraParams) => {
    const network = standardUtilities.network;
    const setDatastore = standardUtilities?.setDatastore;
    const {} = extraParams;
    const response = extraParams?.response;
    const fetchPortfolioPayload = extraParams?.fetchPortfolioPayload;
    const isRetryAllowed = extraParams?.isRetryAllowed;
    const responseData = response?.data;
    const isFetchedErrorShowOnce = await SharedPropsService.getIsFetchedErrorShowOnce();
    if (response?.status === 200 &&
        responseData.status?.toUpperCase() === 'FAILURE') {
        let errorData = responseData?.stepResponseObject?.error;
        if (isFetchedErrorShowOnce === false &&
            isRetryAllowed === true &&
            errorData?.retryNextRTA === true) {
            // retry flow with init
            errorData = {
                ...errorData,
                //This switch is just for display purpose
                assetRepository: AssetRepositoryType[fetchPortfolioPayload?.assetRepository] === AssetRepositoryType.KARVY
                    ? AssetRepositoryType.CAMS
                    : AssetRepositoryType.KARVY
            };
            if (errorData?.retryType === FetchPortfolioModalType.LOADER) {
                await showCamsFetchErrorHandle(standardUtilities, errorData);
                const loaderTime = errorData.loaderTimingInMilliSec ? errorData.loaderTimingInMilliSec : 0;
                setTimeout(async () => {
                    await setDatastore(ROUTE.MF_FETCH_PORTFOLIO, 'fetchPortfolioModals', {
                        visible: false
                    });
                    await retryFetch(standardUtilities, {
                        fetchPortfolioPayload: fetchPortfolioPayload,
                        isRetryAllowed: isRetryAllowed
                    });
                }, loaderTime);
            }
            else {
                await setDatastore(ROUTE.MF_FETCH_PORTFOLIO, 'fetchPortfolioModals', {
                    visible: false
                });
                await retryFetch(standardUtilities, {
                    fetchPortfolioPayload: fetchPortfolioPayload,
                    isRetryAllowed: isRetryAllowed
                });
            }
        }
        else {
            await showCamsFetchErrorHandle(standardUtilities, {
                ...errorData,
                retryType: FetchPortfolioModalType.IMMEDIATE,
            });
        }
    }
};
export const mfcFetchErrorHandle = async (standardUtilities, { errorBody }) => {
    const errorData = errorBody;
    await standardUtilities.setDatastore(ROUTE.MF_FETCH_PORTFOLIO, 'fetchPortfolioModals', {
        height: 0,
        visible: true,
        type: FetchPortfolioModalType.IMMEDIATE,
        title: errorData?.header,
        subtitle: errorData?.message,
        primaryCtaTitle: errorData?.primaryCtaText,
        tertiaryCTATitle: errorData?.tertiaryCtaText,
        primaryCtaAction: errorData?.primaryCtaAction &&
            errorData?.primaryCtaAction !== 'null'
            ? {
                routeId: ROUTE.MF_FETCH_PORTFOLIO,
                type: `${errorData?.primaryCtaAction}`,
                payload: {},
            }
            : undefined,
        tertiaryCTAAction: errorData?.tertiaryCtaAction &&
            errorData?.tertiaryCtaAction !== 'null'
            ? {
                routeId: ROUTE.MF_FETCH_PORTFOLIO,
                type: `${errorData?.tertiaryCtaAction}`,
                payload: {},
            }
            : undefined,
        onModalClose: () => {
            standardUtilities.setDatastore(ROUTE.MF_FETCH_PORTFOLIO, 'fetchPortfolioModals', {
                visible: false,
            });
        },
    });
};
